import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import { comparatorQtr } from '../../../../SharedModules/utilities/utilities';

export const PRDetailTableHead1 = [
  {
    headerName: 'Actions',
    field: 'action',
    filter: false,
    sortable: false,
    enableMenu: false,
    minWidth: Styles.Width_130,
    resizable: true,
    maxWidth: Styles.Width_130,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'ActionCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'NDC',
    field: 'drugSeqNum',
    editable: false,
    resizable: true,
    sort: 'asc',
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_20,
    cellClass: 'ag-cell-action',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    sortingOrder: ['asc', 'desc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },

  {
    headerName: 'Quarter',
    field: 'qtr',
    enableMenu: false,
    resizable: true,
    editable: false,
    sortingOrder: ['asc', 'desc'],
    minWidth: Styles.Width_130,
    comparator: comparatorQtr,

    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellStyle: { 'border-right-color': Styles.BorderColor },
    cellClass: 'ag-cell-action frr-overflow-visible',
  },
  {
    headerName: 'Rebate Program',
    field: 'rebateProgramCd',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_180,
    sortingOrder: ['asc', 'desc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    cellRenderer: 'DrugNameRenderer',
    editable: false,
    columnSpan: 4,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_250,
    sortingOrder: ['asc', 'desc'],
    cellStyle: {
      'border-right-color': Styles.BorderColor,
      'white-space': 'normal',
    },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'FMAC covering',
    field: 'ccFmacActiv',
    hideFilterIcon: true,
    sortable: false,
    editable: false,
    showCheckboxIcon: true,
    minWidth: Styles.Width_150,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellRenderer: 'CheckBoxCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Original number of units',
    field: 'ccOrigUnits',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_180,
    sortingOrder: ['asc', 'desc'],
    wrapHeaderText: true,
    autoHeaderHeight: true,
    dataAlignRight: true,
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Number of units',
    field: 'numOfUnits',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_120,
    sortingOrder: ['asc', 'desc'],
    wrapHeaderText: true,
    autoHeaderHeight: true,
    dataAlignRight: true,
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
